
import {
  getOrderDetails,
  getHotel,
  getTraveler,
  getHotelList,
  submit,
  paymentlist,
  mergelist,
  aliLog,
  remarklist,
  remark,
  afterList,
  refundList,
  emailList,
  logList,
  userList,
  costList,
  changeCost,
  wechatList,
  dispatchList,
  downloadjpg,
  createLink,
  sendWechatTemplate,
  refundFee,
  getQNConfig,
  sendMail,
  sendSMS,
  autoMail,
  getSkuUnit,
  addOrder,
  afterRefund,
  add,
  unsubscribe,
  nounsubscribe,
  verify,
  submitTag,
  saveSupplier,
  getMoneyCode,
  check,
} from "utils/interface";
import { CQ } from "utils/commonQuest";


// 订单信息相关
export const orderDetails = {
  state: {
    // 订单详情
    updateTime: 0,
    orderStatus: {},
    skuName: '',
    skuNumber: '',
    id: 0,
    travelInfo: [],
    orderInfo: [],
    driverInfo: [],
    contactInfo: [],
    passengerInfo: [],
    hotelInfo: [],
    orderNumber: '',
    number: '',
    supplierCode: '',
    submitDate: '',
    verifyTime: '',
    tianmaoCode: '',
    travelCompany: '',
    category: '',
    goodsUrl: '',
    head: '',
    buyersMessage: '',
    surchargeAmount: '',
    isMail: 0,
    tags: [],
    associatedOrder: [],
    data: {},
    errorInfo: {},
    readonly: {},
    fromSource: '',
    fromSourceFrist: '',
    fromSourceSecond: '',
    remark: '',
    phone: '',
    additionals: [],
    url: '',
    taoAccount: '',
    mallAccount: "",
    goTime: "",
    email: "",
    contact: "",
    tabStatus: "tab1",
    skuId: "",
    status: '0',
    group_number: '',
    go_times: 0,
    paymentList: [],
    remarkList: [],
  },
  reducers: {

    modifyReadonly(state) {
      Object.keys(state.readonly).forEach(function (key) {
        if (state.readonly[key] === true) {
          state.readonly[key] = false;
        }
      })
      return {
        ...state
      };
    },
    updatePaymentList(state, data: any) {
      state.paymentList = data;
      return {
        ...state
      };
    },
    updateRemarkList(state, data: any) {
      state.remarkList = data;
      return {
        ...state
      };
    },
    updateTabStatus(state, data: any) {
      state.tabStatus = data;
      return {
        ...state
      };
    },
    // 更新订单详情数据
    updateOrderDetails(state, data: any) {
      state.updateTime = data.update_time;
      state.orderStatus = data.order_status;
      state.skuName = data.sku_name;
      state.skuNumber = data.sku_number;
      state.id = data.id;
      state.status = data.status;
      state.travelInfo = data.fields.travel_info;
      state.orderInfo = data.fields.order_info;
      state.driverInfo = data.fields.driver_info;
      state.contactInfo = data.fields.contact_info;
      state.passengerInfo = data.fields.passenger_info;
      state.hotelInfo = data.fields.hotel_info;
      state.orderNumber = data.order_number;
      state.number = data.number;
      state.supplierCode = data.supplier_code;
      state.submitDate = data.submit_date;
      state.verifyTime = data.verify_time;
      state.tianmaoCode = data.tianmao_code;
      state.travelCompany = data.travel_company;
      state.category = data.category;
      state.goodsUrl = data.goods_url;
      state.head = data.head;
      state.buyersMessage = data.buyers_message;
      state.surchargeAmount = data.surcharge_amount;
      state.isMail = data.is_mail;
      state.tags = data.tags;
      state.associatedOrder = data.associated_order;
      state.fromSource = data.from_source;
      state.fromSourceFrist = data.from_source_frist;
      state.fromSourceSecond = data.from_source_second;
      state.phone = data.phone;
      state.additionals = data.additionals;
      state.taoAccount = data.tao_account;
      state.mallAccount = data.mall_account;
      state.skuId = data.sku_id;
      state.group_number = data.group_number;
      state.go_times = data.go_time;

      state.data['remark'] = data.remark;
      state.data['id'] = data.id;
      state.data['update_time'] = data.update_time;
      if (data.fields.order_info) {
        for (let value of data.fields.order_info) {
          state.data[value['id']] = value['value'];
          state.readonly[value['id']] = value['is_readonly'];
          if (value['is_gotime']) {
            state.goTime = value['value'];
          }
        }
      }
      if (data.fields.travel_info) {
        for (let value of data.fields.travel_info) {
          state.data[value['id']] = value['value'];
          state.readonly[value['id']] = value['is_readonly'];
        }
      }
      if (data.fields.contact_info) {
        for (let value of data.fields.contact_info) {
          state.data[value['id']] = value['value'];
          state.readonly[value['id']] = value['is_readonly'];
          if (value['id'] == '15') {
            state.email = value['value'];
          }
          if (value['id'] == '2') {
            state.contact = value['value'];
          }
        }
      }
      if (data.fields.passenger_info) {
        for (let value of data.fields.passenger_info) {
          state.data[value['id']] = value['value'];
          state.readonly[value['id']] = value['is_readonly'];
        }
      }
      if (data.fields.driver_info) {
        for (let value of data.fields.driver_info) {
          state.data[value['id']] = value['value'];
          state.readonly[value['id']] = value['is_readonly'];
        }
      }
      if (data.fields.hotel_info) {
        for (let item of data.fields.hotel_info) {
          for (let value of item) {
            state.data[value['id']] = value['value'];
            state.readonly[value['id']] = value['is_readonly'];
          }
        }
      }
      if (data.additionals) {
        for (let item of data.additionals) {
          state.readonly[item['id']] = item['is_readonly'];
        }
      }

      // if (process.env.NODE_ENV === "beta" || process.env.NODE_ENV === "beta_hash") {
      //   // 预上线环境
      //   state.data['url'] = "https://admin.cattrip.net";
      // } else {
      //   // 正式环境
      //   state.data['url'] = "https://admin.cattour.cn";
      // }

      state.data['url'] = process.env.REACT_APP_OLDER_SITE_DOMAIN;

      return {
        ...state
      };
    },
    updateDataValue(state, data: any) {
      state.data[data.id] = data.value;
      return {
        ...state
      };
    },
    updateErroInfo(state, data: any) {
      state.errorInfo = data;
      return {
        ...state
      };
    },
  },
  effects: {
    // 获取订单详情
    async getOrderDetails(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getOrderDetails(param));
      callback();
      this.updateOrderDetails(data);
    },
    // 提交订单
    async submit(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(submit(param), true);
      callback(data.res);
      // setTimeout(() => {
      console.log(data.res.code)

      //const params: any = {
      //  id: param.id
      // }; 
      // this.getOrderDetails({
      //   ...params,
      //  callback: () => {
      //   }
      // });


      // },500)
      //this.updateOrderDetails(data);
    },
    // 查询酒店
    async getHotel(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getHotel(param));
      callback(data);
    },
    // 查询常用出行人
    async getTraveler(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getTraveler(param));
      callback(data);
    },
    // 获取常用酒店
    async getHotelList(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getHotelList(param));
      callback(data);
    },
    async paymentlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(paymentlist(param));
      callback(data);
    },
    async paymentlistForTag(payload: any, rootState: any){
      // 等待异步调用的结果
      const data = await CQ(paymentlist(payload));
      console.log('paymentlistForTag', data);
      this.updatePaymentList(data)
    },
    async mergelist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(mergelist(param));
      callback(data);
    },
    async alilog(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(aliLog(param));
      callback(data);
    },
    async getRemarkList(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(remarklist(param));
      this.updateRemarkList(data);
      callback(data);
    },
    async remark(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(remark(param), true);
      callback(data);
    },
    async afterlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(afterList(param));
      callback(data);
    },
    async refundlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(refundList(param));
      callback(data);
    },
    async emaillist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(emailList(param));
      callback(data);
    },
    async loglist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(logList(param));
      callback(data);
    },
    async userlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(userList(param));
      callback(data);
    },
    async costlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(costList(param));
      callback(data);
    },
    async changecost(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(changeCost(param));
      callback(data);
    },
    async wechatlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(wechatList(param));
      callback(data);
    },
    async dispatchlist(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(dispatchList(param));
      callback(data);
    },
    async downloadjpg(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(downloadjpg(param));
      callback(data);
    },
    async createlink(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(createLink(param));
      callback(data);
    },
    async sendWechatTemplate(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(sendWechatTemplate(param));
      callback(data);
    },
    async refundFee(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(refundFee(param));
      callback(data);
    },
    async sendMail(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(sendMail(param));
      callback(data);
    },
    async getQNConfig(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const { data, res } = await CQ(getQNConfig(), true);
      if (res.code !== "0000") {
        console.log(res);
        payload.error("上传失败");
        return;
      }
      callback(data);
    },
    async sendSMS(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(sendSMS(param));
      callback(data);
    },
    async autoMail(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(autoMail(param));
      callback(data);
    },
    async getSkuUnit(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getSkuUnit(param));
      callback(data);
    },
    async addOrder(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(addOrder(param));
      callback(data);
    },
    async afterRefund(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(afterRefund(param));
      callback(data);
    },
    async saveSupplier(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(saveSupplier(param));
      callback(data);
    },
    async add(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(add(param));
      callback(data);
    },
    async unsubscribe(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(unsubscribe(param));
      callback(data);
    },
    async nounsubscribe(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(nounsubscribe(param));
      callback(data);
    },
    async verify(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(verify(param));
      callback(data);
    },
    async submitTag(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(submitTag(param));
      callback(data);
    },
    async getMoneyCode(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getMoneyCode(param));
      callback(data);
    },
    async check(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const callback = payload.callback;
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(check(param));
      callback(data);
    },
  }
};
